import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

const CheckboxIndeterminate = ({
  label = '',
  checked = false,
  indeterminate = false,
  handleChange,
  disabled = false,
  className = '',
}) => {
  const inputRef = useRef(null)

  useEffect(() => {
    inputRef.current.checked = checked
    inputRef.current.indeterminate = indeterminate
  }, [checked, indeterminate])

  const handleCheckboxChange = (e) => {
    const { checked, indeterminate } = e.target
    handleChange({ checked, indeterminate })
  }

  return (
    <label
      className={cn(
        'checkbox-with-label -checkbox',
        {
          '-indeterminate': indeterminate,
        },
        className
      )}
    >
      <input
        className="checkbox-with-label__input"
        type="checkbox"
        onChange={handleCheckboxChange}
        ref={inputRef}
        disabled={disabled}
      />
      <div
        className={cn('checkbox-with-label__checkbox', {
          '-disabled': disabled,
        })}
      />
      <div>
        <div className="top-label">{label}</div>
      </div>
    </label>
  )
}

CheckboxIndeterminate.propTypes = {
  label: PropTypes.string,
  checked: PropTypes.bool,
  indeterminate: PropTypes.bool,
  handleChange: PropTypes.func,
  disabled: PropTypes.bool,
  className: PropTypes.string,
}

export default CheckboxIndeterminate
